import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrows-exchange-2', 'ArrowsExchange2', [["path",{"d":"M17 10h-14l4 -4","key":"svg-0"}],["path",{"d":"M7 14h14l-4 4","key":"svg-1"}]]);